(function () {
  if (typeof window === 'undefined') return;

  var GRADE_LABELS = {
    Select: 'Select (G/SI1)',
    Premium: 'Premium (F/VS2)',
    Signature: 'Signature (E/VVS2)',
  };

  function formatMass(value) {
    if (value == null || value === '') return null;
    var num = parseFloat(value);
    if (isNaN(num)) return String(value);
    return num.toFixed(2) + ' ct';
  }

  function getProductInfo(el) {
    return el && el.closest ? el.closest('product-info.livia-product') : null;
  }

  function readOptionValue(productInfo, matchers) {
    var groups = productInfo.querySelectorAll('variant-selects .variant__option__group');
    for (var i = 0; i < groups.length; i++) {
      var legend = groups[i].querySelector('.variant__option__name');
      if (!legend) continue;
      var label = '';
      legend.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) label += node.textContent;
      });
      label = label.trim() || legend.textContent.trim();
      var lower = label.toLowerCase();
      if (!matchers.some(function (m) { return lower.indexOf(m) !== -1; })) continue;

      var selectedSpan = groups[i].querySelector('[data-selected-value]');
      if (selectedSpan && selectedSpan.textContent.trim()) {
        return selectedSpan.textContent.trim();
      }
      var checked = groups[i].querySelector('input[type="radio"]:checked, select option:checked');
      if (checked) return (checked.value || checked.textContent).trim();
    }
    return null;
  }

  function readMass(productInfo) {
    var active = productInfo.querySelector('.variant__option__values--mass a.active span');
    if (active) return active.textContent.trim();
    var legend = productInfo.querySelector('[data-mass-variants] .variant__option__name span');
    if (legend) return legend.textContent.trim();
    var meta = productInfo.querySelector('[data-livia-product-meta]');
    if (meta) {
      try {
        var parsed = JSON.parse(meta.textContent);
        if (parsed.mass != null) return formatMass(parsed.mass);
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  function readQuality(productInfo) {
    var checked = productInfo.querySelector('.variant__option__values--jakosc input[type="radio"]:checked');
    if (checked) return GRADE_LABELS[checked.value] || checked.value;
    return readOptionValue(productInfo, ['jako']);
  }

  function updateSpecs(productInfo) {
    var panel = productInfo.querySelector('[data-livia-product-specs]');
    if (!panel) return;

    function setValue(key, value) {
      var el = panel.querySelector('[data-spec-value="' + key + '"]');
      var row = panel.querySelector('[data-spec-row="' + key + '"]');
      if (!el) return;
      if (value) {
        el.textContent = value;
        if (row) row.hidden = false;
      } else if (row && !row.classList.contains('la-product-specs__row--fixed')) {
        row.hidden = true;
      }
    }

    setValue('mass', readMass(productInfo));
    setValue('quality', readQuality(productInfo));
    setValue('gold', readOptionValue(productInfo, ['kolor', 'złoto', 'zloto']));
    setValue('size', readOptionValue(productInfo, ['rozmiar', 'długość', 'dlugosc']));
  }

  function initProductInfo(productInfo) {
    updateSpecs(productInfo);
  }

  document.addEventListener('change', function (event) {
    var productInfo = getProductInfo(event.target);
    if (!productInfo) return;
    if (event.target.matches('input[type="radio"], select')) {
      updateSpecs(productInfo);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info.livia-product').forEach(initProductInfo);
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('product-info.livia-product').forEach(initProductInfo);
  });

  document.addEventListener('product-info:loaded', function (event) {
    var productInfo = event.target;
    if (productInfo && productInfo.classList.contains('livia-product')) {
      initProductInfo(productInfo);
    }
  });
})();
